import React from 'react';

import { LinearProgress } from '@material-ui/core';

import styles from './LinearProgressIndicator.module.scss';

type LinearProgressIndicatorProps = {
	percentagePlayed: number;
};

export const LinearProgressIndicator: React.FC<
	LinearProgressIndicatorProps
> = ({ percentagePlayed }) => {
	const getPercentagePlayedValue = (): number => {
		if (percentagePlayed < 0) {
			return 0;
		} else if (percentagePlayed > 100) {
			return 100;
		} else {
			return percentagePlayed;
		}
	};

	const rootClasses = [
		styles['line-progress-indicator__root'],
	];

	return (
		<LinearProgress
			className="video_tile-progress_bar"
			color="primary"
			variant="determinate"
			value={getPercentagePlayedValue()}
			classes={{
				root: rootClasses.join(' '),
				colorPrimary: styles['line-progress-indicator__color-primary'],
				barColorPrimary:
					styles['line-progress-indicator__bar-color-primary'],
			}}
		/>
	);
};

export default LinearProgressIndicator;
